import { mediaConstants } from '../constants';

const initialState = {
    loading: false,
    medias: [],
    error: null,
    creatingMedia: false,
    createError: null,
    updatingMedia: false,
    updateError: null,
};

const mediaReducer = (state = initialState, action) => {
    switch (action.type) {
        case mediaConstants.FETCH_ALLMEDIA_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case mediaConstants.FETCH_ALLMEDIA_SUCCESS:
            return {
                ...state,
                loading: false,
                medias: action.medias,
                error: null
            };
        case mediaConstants.FETCH_ALLMEDIA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case mediaConstants.CREATE_MEDIA_REQUEST:
            return {
                ...state,
                creatingMedia: true,
                createError: null,
            };
        case mediaConstants.CREATE_MEDIA_SUCCESS:
            return {
                ...state,
                creatingMedia: false,
                medias: action.medias
            };
        case mediaConstants.CREATE_MEDIA_FAILURE:
            return {
                ...state,
                creatingMedia: false,
                createError: action.payload,
            };
        case mediaConstants.UPDATE_MEDIA_REQUEST:
            return {
                ...state,
                updatingMedia: true,
                updateError: null,
            };
        case mediaConstants.UPDATE_MEDIA_SUCCESS:
            return {
                ...state,
                medias: action.medias,
                updatingMedia: false,
                updateError: null,
            };
        case mediaConstants.UPDATE_MEDIA_FAILURE:
            return {
                ...state,
                updatingMedia: false,
                updateError: action.payload,
            };
        case mediaConstants.DELETE_MEDIA_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case mediaConstants.DELETE_MEDIA_SUCCESS:
            return {
                ...state,
                loading: false,
                medias: state.medias.filter(m => m.MediaID !== action.payload),
            };
        case mediaConstants.DELETE_MEDIA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default mediaReducer;
